<script>
export default {
    name: 'ImageWrapper',

    props: {
        src: null,
        background: Boolean,
        contain: Boolean,
        cover: Boolean,
        fill: Boolean,
        rounded: Boolean,
        skeletonLoader: Boolean,
        width: {
            type: String,
            default: undefined,
        },
        height: {
            type: String,
            default: undefined,
        },
        errorImg: {
            type: String,
            default: undefined,
        },
        tag: {
            type: String,
            default: undefined,
        },
    },

    computed: {
        url() {
            return this.src ? this.src : undefined
        },
        backgroundImage() {
            return {
                src: this.url,
                ...this.lazyContainer,
            }
        },
        lazyContainer() {
            return this.skeletonLoader
                ? { error: this.errorImg, loading: '/images/placeholder.svg' }
                : { error: this.errorImg }
        },
    },
}
</script>

<template lang="pug">
.image-wrapper.background-image(
    v-if="background"
    v-lazy:background-image="backgroundImage"
    :class="{'background-contain': contain, 'rounded-circle': rounded}"
    :style="{width: `${width}`, height: `${height}`}"
)
.image-wrapper.image(
    v-lazy-container="lazyContainer"
    :class="{'image-fill': fill, 'image-contain': contain, 'image-cover': cover, 'rounded-circle': rounded}"
    :style="{width: `${width}`, height: `${height}`}"
    v-else)
    img(:data-src="url" :alt="tag" lazy='loading')
</template>
